import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';


const ConfirmationModal = (
    {
        show,
        onHide,
        onConfirm,
        action,
        IsActive
    }
) => {


        const [confirmText, setConfirmText] = useState('');
        const [showError, setShowError] = useState(false);


        const actionConfig = {
            eliminar: {
                title: 'Eliminar Factura',
                message: 'Esta acción eliminará permanentemente la factura de la base de datos. Esta acción es irreversible.',
                confirmWord: 'ELIMINAR',
                buttonVariant: 'danger',
                buttonText: 'Eliminar Factura'
            },
            cancelar: {
                title: IsActive ? 'Cancelar Factura' : 'Factura Ya Cancelada',
                message: IsActive
                    ? 'Esta acción cambiará el estatus de la factura a "Cancelada" en el sistema. La factura no será eliminada de la base de datos.'
                    : 'Esta factura ya está cancelada en el sistema.',
                confirmWord: IsActive ? 'CANCELAR' : null,
                buttonVariant: IsActive ? 'warning' : 'secondary',
                buttonText: IsActive ? 'Cancelar Factura' : 'Entendido',
                disabled: !IsActive
            },
            cancelarSAT: {
                title: IsActive ? 'Cancelar Factura en el SAT' : 'Factura Ya Cancelada',
                message: IsActive
                    ? 'Esta acción enviará la solicitud de cancelación de la factura directamente al SAT. Esta acción es irreversible y puede tardar varios minutos en procesarse.'
                    : 'Esta factura ya está cancelada en el sistema.',
                confirmWord: IsActive ? 'CANCELARSAT' : null,
                buttonVariant: IsActive ? 'info' : 'secondary',
                buttonText: IsActive ? 'Cancelar en SAT' : 'Entendido',
                disabled: !IsActive
            }
        };

        const config = actionConfig[action] || actionConfig.eliminar;


        const handleConfirm = () => {
            // Si la factura ya está cancelada, solo cerrar el modal
            if (!IsActive && (action === 'cancelar' || action === 'cancelarSAT')) {
                handleClose();
                return;
            }

            if (confirmText.trim().toUpperCase() === config.confirmWord) {
                onConfirm();
                handleClose();
            } else {
                setShowError(true);
            }
        };

        const handleClose = () => {
            setConfirmText('');
            setShowError(false);
            onHide();
        };

        return (
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-danger">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {config.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <p className="mb-3">{config.message}</p>

                        <Alert variant={action === 'eliminar' ? 'danger' : 'warning'} className="mb-3">
                            <i className="fas fa-info-circle me-2"></i>
                            {config.confirmWord ? (
                                <>Para confirmar esta acción, escriba <strong>{config.confirmWord}</strong> en el campo de abajo.</>
                            ) : (
                                <>Esta factura ya no puede ser cancelada porque ya está inactiva.</>
                            )}
                        </Alert>


                        <Form.Group>
                            <Form.Label>Escriba <strong>{config.confirmWord}</strong> para confirmar:</Form.Label>
                            <Form.Control
                                type="text"
                                value={confirmText}
                                onChange={(e) => setConfirmText(e.target.value)}
                                placeholder={`Escriba ${config.confirmWord}`}
                                className={showError ? 'is-invalid' : ''}
                                onCopy={(e) => e.preventDefault()}
                                onPaste={(e) => e.preventDefault()}
                                onCut={(e) => e.preventDefault()}
                            />
                            {showError && (
                                <div className="invalid-feedback">
                                    Debe escribir exactamente "{config.confirmWord}" para continuar.
                                </div>
                            )}
                        </Form.Group>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button
                        variant={config.buttonVariant}
                        onClick={handleConfirm}
                        disabled={!confirmText.trim()}
                    >
                        {config.buttonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

ConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    action: PropTypes.oneOf(['eliminar', 'cancelar', 'cancelarSAT']).isRequired,
    IsActive: PropTypes.bool

};

export default ConfirmationModal;
